export default __webpack_public_path__ + "static/media/97.bbdc67a4.png";